<script setup lang="ts">
/** Aura AGM — 문서 [[Signers]] 자리. 공용 SignersField UI 재사용(기존 스타일과 동일). */
import { computed, inject } from 'vue';
import SignersField from '@/features/startTask/preset_task/my/preset/components/resignation/signers/SignersField.vue';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';
import { useAgmSigners, useAgmEntityCd } from './agmSignersContext';
import { DOC_SCOPE } from './useCddFill';

const props = withDefaults(defineProps<{ varKey: string; boardLabel?: string }>(), { boardLabel: '' });
const scope = inject(DOC_SCOPE, '');
const fullKey = computed(() => scope + props.varKey);
const ctx = useAgmSigners();
const entityCd = useAgmEntityCd(); // 엔티티 있으면 직책별 서명자 선택 다이얼로그 활성화
const signers = computed(() => ctx.signersOf(fullKey.value));
function onUpdate(list: SignerEntry[]) { ctx.setSigners(fullKey.value, list); }
</script>

<template>
  <SignersField
    :model-value="signers"
    :board-label="boardLabel"
    :var-key="fullKey"
    :entity-cd="entityCd"
    @update:model-value="onUpdate"
  />
</template>
